import qs from "qs";
import { ApiErrorResultType, ApiErrorType, RequestProps } from "./types";

// 파라미터 변환 처리
export const getRequestParams = (obj: RequestProps) => {
  const { method, isFileUpload, isErrorAlert = true } = obj;

  let { params, data, paramsSerializer, headers } = obj;

  // GET인 경우
  if (method === "GET") {
    if (!paramsSerializer) {
      paramsSerializer = (objParams): string => {
        return qs.stringify(objParams, {
          arrayFormat: "repeat",
          skipNulls: true,
        }); // array 포맷 변환 및 null값 제외 처리
      };
    }
  } else {
    const objData = data || params;
    // 파일 업로드인 경우
    if (isFileUpload) {
      headers = { ...headers, "Content-Type": "multipart/form-data" };

      const objData = obj.data || obj.params;
      if (objData) {
        data = new FormData();

        Object.keys(objData).forEach((key) => {
          const value = objData[key];
          if (value) {
            // 배열인 경우
            if (Array.isArray(value)) {
              value.forEach((val) => {
                data.append(key, val);
              });
            } else {
              data.append(key, value);
            }
          }
        });
      }
    } else {
      data = objData
        ? qs.stringify(objData, { arrayFormat: "repeat", skipNulls: true })
        : undefined; // GET이 아닐때는 data로 넘겨줘야됨
    }
    params = undefined;

    // content-type이 없는 경우
    if (!headers || !headers["Content-Type"]) {
      headers = {
        ...headers,
        "Content-Type": "application/x-www-form-urlencoded",
      };
    }
  }

  return {
    ...obj,
    headers,
    params,
    data,
    paramsSerializer,
    isErrorAlert,
  };
};

// api 에러 발생 시 알럿 메세지 조회
export const getApiErrorResult = (error: any): ApiErrorResultType => {
  let isShow = true; // 에러메세지 노출 여부
  let errorMessage = "";
  // let isLogout = false; // 로그아웃 여부 (토큰 파기)

  // axios 에러인 경우
  if (error.isAxiosError) {
    // 결과가 있는 경우
    if (error.response) {
      const { code }: ApiErrorType = error.response.data;

      // 토큰에 이상이 있는 경우
      if (error.response.status === 401 && code === 401) {
        // isLogout = true;
        isShow = false; // 메시지 노출 안함
      }

      // 메세지 노출
      const { message }: ApiErrorType = error.response.data;
      errorMessage =
        !!message && typeof message === "string"
          ? message
          : "일시적으로 문제가 발생했습니다. 잠시 후에 다시 시도해주세요. [SU02]"; // 서버 에러 (개발인 경우 빌드중인 확률 높음)
    } else {
      errorMessage =
        "데이터 요청에 실패하였습니다. 사용중인 네트워크 상태를 확인해주세요."; // 네트워크 오류
    }
  } else {
    if (
      !!error?.customErrorMessage &&
      typeof error?.customErrorMessage === "string"
    ) {
      errorMessage = error.customErrorMessage;
    } else {
      // 로직 오류
      errorMessage =
        "일시적으로 문제가 발생했습니다. 잠시 후에 다시 시도해주세요. [LE02]";
    }
  }

  return { isShow, errorMessage };
};
